up.compiler(
  '[data-scroll-to-career-box-more-info]',
  (element, { headerContent }: { headerContent: string }) => {
    const xpath = `//*[contains(text(), '${headerContent}') and (self::h2 or self::h3)]`

    up.on(element, 'click', (event) => {
      const scrollTarget = document.evaluate(
        xpath,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null,
      ).singleNodeValue
      up.reveal(scrollTarget, { top: true })
    })
  },
)
